module.exports = __webpack_public_path__ + "img/cw_yf_fuKuanHeXiao.750ef749.svg";